import { sharedConfig } from '@witkac/kartamiejska-shared';

import { config } from '@/utils/config';
import { notificationsMixin } from '@/mixins/notifications';

/**
 * Mixin uploadu
 *
 */
export const uploadMixin = {
  mixins: [notificationsMixin],
  props: {
    // Schema medii
    schema: { type: Object, required: true },
    // identyfikator inputa
    inputId: {
      type: String,
      required: false,
      default: ''
    }
  },
  data() {
    return {
      mediaURL: config.mediaURL,
      queryString: sharedConfig.sizes.gallery.big.queryString
    };
  },
  methods: {
    handleError(error) {
      this.notifyError(error);
    }
  }
};
